import { system } from 'styled-system';
import { getPxAbsolute } from '../internal';

const borderBottomLeftRadius = system({
  radiusTR: {
    property: 'borderTopRightRadius',
    scale: 'radii',
    transform: getPxAbsolute,
  },
});

export default borderBottomLeftRadius;
